module.exports = __webpack_public_path__ + "img/notebook-hermes.e3c63b1f.webp";